import { render, staticRenderFns } from "./OldPlansSidebar.vue?vue&type=template&id=512a72a7"
import script from "./OldPlansSidebar.vue?vue&type=script&lang=js"
export * from "./OldPlansSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports